
const postalCodeValidatorMX = (postcode) => {
    const zipFormat = new RegExp('^[0-9]{5}$');
    return postcode && zipFormat.test(postcode);
};

export default postalCodeValidatorMX;
